module.exports = __webpack_public_path__ + "img/Technicals10.86889cc.png";